import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import type { routes } from '~/providers/RouterProvider/router.routes';
import type { Params } from '~/providers/RouterProvider/router.types';

import { useActivateAccount } from '~/api/auth';
import { ErrorScreen, LoadingScreen } from '~/components';

export const Activate = () => {
  const { isError, mutate: activateAccount } = useActivateAccount();

  const { t } = useTranslation(['auth', 'common']);

  const { activationKey } = useParams<Params<typeof routes.activate>>();

  useEffect(() => {
    if (!activationKey) return;

    activateAccount({ activationKey });
  }, [activateAccount, activationKey]);

  return isError ? <ErrorScreen /> : <LoadingScreen>{t('auth:activationPage.loading')}</LoadingScreen>;
};
